import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { TranslatePipe } from '../pipes/translate.pipe';

@Injectable({
	providedIn: 'root'
})
export class NotifyService {

	constructor(
		private _snack: MatSnackBar,
		private _trans: TranslatePipe,
	) {	}

	warn(message: string, action?: string, config: MatSnackBarConfig = {duration: 10000}, translate: any = true) {
		if (!config.panelClass) { config.panelClass = ['warn']; }
		if (!config.hasOwnProperty('duration')) { config.duration = 0; }
		return this._notify(message, action, config, translate);
	}

	success(message: string, action?: string, config: MatSnackBarConfig = {duration: 3000}, translate: any = true) {
		if (!config.panelClass) { config.panelClass = ['accent']; }
		return this._notify(message, action, config, translate);
	}

	inform(message: string, action?: string, config: MatSnackBarConfig = {duration: 5000}, translate: any = true) {
		return this._notify(message, action, config, translate);
	}

	dismiss() {
		return this._snack.dismiss();
	}

	private _notify(message: string, action = '', config: MatSnackBarConfig, translate: any) {
		if (translate) {
			const obj = translate === true ? null : translate;
			message = this._translate(message, translate);
			action = this._translate(action, translate);
		}
		if (!config.panelClass) { config.panelClass = ['primary']; }
		return this._snack.open(message, action, config);
	}

	private _translate(text: string, obj?: any) {
		// console.log('what?')
		return this._trans.transform(text, obj);
	}
}
